<template>
  <d-container fluid class="main-content-container p-4">
    <d-card title="Exporter les comptes" class="card-small">
      <d-card-header>
        <h3 class="text-center">Exporter les comptes</h3>
      </d-card-header>
      <d-card-body>
        <d-form-row>
          <d-col class="pr-3 border-right">
            <c-input type="select" label="Format d'export" :options="formatOptions" v-model="format"/>
            <c-input type="select" label="Séparateur" :options="delimiterOptions" v-model="delimiter"/>
            <c-input type="number" label="Nombre max de compte(s)" placeholder="Laissez vide pour tout exporter"
                     v-model="limit" :state="limitState">
              Veuillez saisir un nombre positif ou laissez vide
            </c-input>
          </d-col>
          <d-col class="ml-2">
            <c-input
              type="multiselect" label="Colonnes à exporter" placeholder="Sélectionnez les colonnes à exporter"
              :options="columnsOptions" v-model="columns" :state="columnsState"
            >
              Veuillez sélectionner les colonnes à exporter
            </c-input>
            <c-input type="select" label="Activation" :options="activationOptions" v-model="enabled"
                     :state="filtersState">
              Veuillez sélectionner au moins un filtre
            </c-input>
            <c-input type="select" label="Identité" :options="identityOptions" v-model="verified"
                     :state="filtersState">
              Veuillez sélectionner au moins un filtre
            </c-input>
            <c-input type="select" label="Profil" :options="profileOptions" v-model="merchant"
                     :state="filtersState">
              Veuillez sélectionner au moins un filtre
            </c-input>
          </d-col>
        </d-form-row>
      </d-card-body>
      <d-card-footer>
        <d-input-group class="justify-content-center">
          <c-input
            type="filename" class="w-50" placeholder="Nom du fichier"
            v-model="filename" :extension="extension" :state="filenameState"
          >
            Veuillez saisir un nom de fichier valide
          </c-input>
          <c-button-spinner class="inline-btn ml-1" variant="primary" :fetching="fetching" @click="onDownload">
            <template slot="icon"><i class="fa fa-download"></i></template>
            Télécharger
          </c-button-spinner>
          <vue-json-csv
            ref="csv"
            :data="users" :fields="csvFields" :labels="csvLabels"
            :name="csvFilename" :delimiter="delimiter"
          >
            <span></span>
          </vue-json-csv>
        </d-input-group>
      </d-card-footer>
    </d-card>
  </d-container>
</template>

<script>
import VueJsonCsv from "vue-json-csv"
import {Api, DateFormatter, Regex, Toast} from "@/helpers"

export default {
  title: "Exporter les comptes",
  components: {VueJsonCsv},
  data() {
    return {
      users: [],

      fetching: false,
      submitted: false,

      format: "CSV",
      delimiter: ";",
      limit: "",

      columns: [
        {text: "Identifiant", value: "username"},
        {text: "Nom", value: "last_name"},
        {text: "Prénom", value: "first_name"},
        {text: "Sexe", value: "gender"},
        {text: "Adresse email", value: "email"},
        {text: "Numéro de tél.", value: "phone_number"},
      ],
      enabled: null,
      verified: null,
      merchant: null,

      filename: "My-CoolPay_Users_" + DateFormatter.forFilename(),
    }
  },
  computed: {
    csvFields() {
      return this.columns.map(c => c.value)
    },
    csvLabels() {
      return Object.fromEntries(this.columns.map(c => [c.value, c.text]))
    },
    csvFilename() {
      return this.filename + this.extension
    },
    columnsOptions() {
      return [
        {text: "Identifiant", value: "username"},
        {text: "Nom", value: "last_name"},
        {text: "Prénom", value: "first_name"},
        {text: "Sexe", value: "gender"},
        {text: "Adresse email", value: "email"},
        {text: "Numéro de tél.", value: "phone_number"},
      ]
    },
    activationOptions() {
      return [
        {text: "Tous les comptes", value: null},
        {text: "Activés", value: true},
        {text: "Non activés", value: false},
      ]
    },
    identityOptions() {
      return [
        {text: "Tous les comptes", value: null},
        {text: "Vérifiés", value: true},
        {text: "Non vérifiés", value: false},
      ]
    },
    profileOptions() {
      return [
        {text: "Tous les comptes", value: null},
        {text: "Marchands", value: true},
        {text: "Particuliers", value: false},
      ]
    },
    formatOptions() {
      return [{text: "CSV", value: "CSV"}]
    },
    delimiterOptions() {
      return [{text: ";", value: ";"}, {text: ",", value: ","}]
    },
    extension() {
      return ".csv"
    },
    limitState() {
      return !this.submitted || Regex.isEmptyOrStrictPositiveInteger(this.limit)
    },
    columnsState() {
      return !this.submitted || this.columns.length > 0
    },
    filtersState() {
      return !this.submitted || (this.enabled != null || this.verified != null || this.merchant != null)
        ? null : false
    },
    filenameState() {
      return !this.submitted || Regex.isValidFilename(this.filename)
    },
  },
  methods: {
    isFormValid() {
      return Regex.isEmptyOrStrictPositiveInteger(this.limit)
        && this.columns.length > 0
        && (this.enabled != null || this.verified != null || this.merchant != null)
        && Regex.isValidFilename(this.filename)
    },
    onDownload() {
      this.submitted = true

      if (!this.isFormValid()) return

      this.fetching = true
      Api.get("/user/export", {
        columns: this.csvFields,
        enabled: this.enabled,
        verified: this.verified,
        merchant: this.merchant,
        limit: this.limit || null
      })
        .then(res => {
          this.users = res.data.users
          if (!this.users.length)
            Toast.info("Aucun compte trouvé")
          else {
            Toast.loading(`Génération du fichier ${this.format}...`)
            setTimeout(() => {
              Toast.loadingToast.goAway()
              this.$refs.csv.generate()
            }, 2000)
          }
        })
        .catch(err => this.error = err)
        .then(() => {
          this.fetching = false
          this.submitted = false
        })
    }
  }
}
</script>
